<div class="flex flex-col item-center justify-center gap-2">
  <h2>{{ data.heading }}</h2>
  <div class="w-min h-min">
    <!-- -->
    <img [src]="data.img" alt="img" class="w-full h-full" />
  </div>
</div>
